import { create } from 'zustand'

interface CreateTableDialogState {
  /** The Add Table panel is open (CreateTableDialogHost, in the app shell). */
  open: boolean
  openCreateTable: () => void
  closeCreateTable: () => void
}

/**
 * Opens the one Add Table panel from anywhere: a table's Add menu, or the
 * Tables menu's footer in the sidebar, whose flyout closes under it.
 */
export const useCreateTableDialogStore = create<CreateTableDialogState>((set) => ({
  open: false,
  openCreateTable: () => set({ open: true }),
  closeCreateTable: () => set({ open: false }),
}))
